import React from 'react';
import Card from 'antd/es/card';

import FieldUpdatesFeedback from '../../hoc/FieldUpdatesFeedback';
import EditableDateField from '../../components/EditableDateField/EditableDateField';

const Date = (data, saveFunc) => (
  <Card className="card-details" key={data.id} style={{ position: 'relative', marginBottom: '1em' }}>
    <table className="table-details">
      <tbody>
        <tr>
          <td>{data.label}</td>
          <td>
            <FieldUpdatesFeedback updateKey={data.id} model={data.model}>
              <EditableDateField
                initialValue={data}
                _update={saveFunc}
              />
            </FieldUpdatesFeedback>
          </td>
        </tr>
      </tbody>
    </table>
  </Card>
);

export default Date;
